import DialogRestaurant from './DialogRestaurant';

export default DialogRestaurant;
